import React, { FunctionComponent } from "react";
import classNames from "classnames";

import Link from "../../../vendor/redux-first-router-link";
import NavBarRedesignSelectionLine from "./nav_bar_redesign_selection_line";
import resolveNavRoute, { NavRouteContext } from "./nav_bar_redesign_route";
import { RedesignNavItem } from "./nav_bar_redesign_options";

export type Props = {
  item: RedesignNavItem
  active: boolean
  routeContext: NavRouteContext
};

// A single labeled top-nav destination (icon + label). Active state is driven by whether the
// current page belongs to this item's pageNames (same logic as the legacy dropdown's selection).
// The active tab also draws the selection line (Figma "Type=Underline" top-nav variants).
const NavBarRedesignDestination: FunctionComponent<Props> = ({ item, active, routeContext }) => {
  return <Link
    className={classNames("NavBarRedesign-destination", { "NavBarRedesign-destination--active": active })}
    to={resolveNavRoute(item.base, routeContext)}
    aria-current={active ? "page" : undefined}
  >
    <span className="NavBarRedesign-destinationIcon">{item.renderIcon(active)}</span>
    <span className="NavBarRedesign-destinationLabel" style={item.labelMinWidth ? { minWidth: item.labelMinWidth } : undefined}>
      {item.label}
    </span>
    {active && <NavBarRedesignSelectionLine/>}
  </Link>;
};

export default NavBarRedesignDestination;
